import axios from 'axios';

import { Address, AddressLookupResponse } from '../domain/address';
import { cleanInputObject } from '../general/utils/form';

const lookupAddress: (address: Address) => Promise<AddressLookupResponse> = (address) =>
  axios
    .post<AddressLookupResponse>('/qualification/street_address', cleanInputObject({ raw: address }))
    .then((res) => res.data);

const lookupAddressCardOrders: (address: Address) => Promise<AddressLookupResponse> = (address) =>
  axios
    .post<AddressLookupResponse>('/qualification/street_address/card_orders', cleanInputObject({ raw: address }))
    .then((res) => res.data);

export { lookupAddress, lookupAddressCardOrders };
